
const Unauthorized = () => {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4">
        <div className="max-w-md text-center p-8 bg-white shadow-xl rounded-2xl">
          <h1 className="text-6xl font-bold text-red-500">403</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mt-4">Unauthorized Access</h2>
          <p className="text-gray-600 mt-2">
            You do not have permission to view this page.
          </p>
          <a
            href="/"
            className="inline-block mt-6 px-6 py-2 bg-red-500 text-white font-semibold rounded-md hover:bg-red-600 transition"
          >
            Go Home
          </a>
        </div>
      </div>
    );
  };
  
  export default Unauthorized;
  